import axios from 'axios';
import isEmpty from 'lodash/isEmpty';

import {
  BASE_USER_URL,
} from './url';

import { DEFAULT_ERROR } from '../components/Common/constants';

const cleanAgentList = (data = []) => (
  (!isEmpty(data))
    ? (
      data.map(agent => ({
        id: agent.id,
        phone: agent.phone,
        email: agent.email,
        userId: agent.userId,
        isActive: agent.is_active,
        firstName: agent.first_name,
        lastName: agent.last_name,
        action: (agent.is_active) ? 'deactivate' : 'activate',
      }))
    ) : []
);

export function fetchAgentList(handleSuccess, handleFailure) {
  const url = `${BASE_USER_URL}agent/`;
  axios({
    method: 'get',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    url,
  })
    .then((response) => {
      handleSuccess(cleanAgentList(response.data));
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err);
    });
}

export function changeAgentStatus(id, isActive, handleSuccess, handleFailure) {
  const url = `${BASE_USER_URL}agent/${id}/`;
  axios({
    method: 'put',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    data: {
      is_active: isActive,
    },
    url,
  })
    .then(() => {
      handleSuccess();
    }, (err) => {
      if (err.status === 500 || err.status === 404) {
        err.data = DEFAULT_ERROR;
      }
      handleFailure(err);
    });
}



// WEBPACK FOOTER //
// ./master/jsx/actions/agents_actions.js